import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '@packages/ng-shared-services';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
})
export class ToastContainerComponent {
  public toastService = inject(ToastService);

  getToastType(classname: string): string {
    if (classname?.includes('success')) return 'success';
    if (classname?.includes('danger') || classname?.includes('error')) return 'error';
    if (classname?.includes('warning')) return 'warning';
    return 'info';
  }
}
